import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import sha1 from 'js-sha1'
import {
  useHistory,
  Link
} from 'react-router-dom'

import Text from './Form/Text'
import Password from './Form/Password'
import Container from './Container'
import flatten from './Lib/flatten'

const ResetResult = () => {

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="p-4 text-center bg-white md:w-1/2">
        <div>
          <h2 className="mb-4 text-xl wght-semibold">Success</h2>
          <span className="wght-semibold">Your password has been changed.</span>
          <div className="flex items-end justify-center mt-4">
            <Link
                to={`/login`}
                className="text-xs cursor-pointer hover:wght-semibold hover:text-primary"
              >Return to login page &#8599;
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResetResult